// extracted by mini-css-extract-plugin
module.exports = {"BooksLoading":"BooksLoading_BooksLoading__1O_w9","BooksLoading_Icon":"BooksLoading_BooksLoading_Icon__4n31p"};